import { PAYMENT_APP_VERSION } from '@web-publish-id/payment-shared/const/index'

/** 支付组件SDK版本 */
export const PAYMENT_COM_SDK_VERSION = 'com.' + PAYMENT_APP_VERSION
